import { Button, Table, TableColumnProps } from "antd";
import React, { ForwardedRef, useEffect, useMemo, useState } from "react";
import { EditableCell, EditableRow } from "./EditTable";
import "./TableInputAdd.scss";
import { AddBtnSVG, SubBtnSVG } from "assets";
import { SpinProps } from "antd/lib/spin";
import { TableRowSelection } from "antd/es/table/interface";

interface TableInputAddProps {
  data: any;
  column: any;
  setData: any;
  pagination?: boolean | any;
  loading?: boolean | SpinProps;
  scroll?: any;
  onRow?: any;
  rest?: any;
  rowSelection?: any;
  disabled?: boolean;
  icdList: any;
  count2: any;
  setCount2: any;
}

const TableInputAdd2 = ({
  data,
  column,
  setData,
  disabled,
  icdList,
  count2,
  setCount2,
  ...rest
}: TableInputAddProps): JSX.Element => {
  const addRowTb1 = () => {
    const newData = {
      key: count2,
      maIcd: ``,
      tenIcd: '',
      ghiChu: ``,
    };
    setData([...data, newData]);
    setCount2(count2 + 1);
  };

  column.some((item) => {
    if (item.key == "action") {
      item.title = (
        <Button
          onClick={addRowTb1}
          icon={<AddBtnSVG />}
          className="btn-add-sub"
        />
      );
      item.render = (_, record: { key: React.Key }, index) => {
        return <Button
          danger
          onClick={() => removeRowTb1(record.key)}
          icon={<SubBtnSVG />}
          className="btn-add-sub"
        />
      } 
    }
  });

  const removeRowTb1 = (key) => {
    const newData = data.filter((item) => item.key !== key);
    setData(newData);
  };
 const checkDonThuoc = (dt) => {
    let res = true;
    dt.map(dt => {
      if(dt.id === null || dt.id === undefined) {
        res = res && false;
      }
      else res = res && true;
    })
    return res;
  }
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
    setCount2(count2 + 1)
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = column.map((col) => {
    if (col.dataIndex == 'maIcd') {
      return {
        ...col,
        onCell: (record, index) => ({
          record,
          editable: col.editable,
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          index: index,
          rules: col.rules,
          handleSave,
          icdList,
          type: col.type,
          disabled: disabled ?? col.disabled,
          value: col.value,
        }),
      }
    }
    if (col.dataIndex == "tenIcd") {
      return {
        ...col,
        onCell: (record, index) => ({
          record,
          editable: col.editable,
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          index: index,
          rules: col.rules,
          handleSave,
          icdList,
          type: col.type,
          disabled: disabled ?? col.disabled,
          value: col.value,
        }),
      }
    }
    return {
      ...col,
      onCell: (record, index) => ({
        record,
        editable: col.editable,
        selected: col.selected,
        dataIndex: col.dataIndex,
        title: col.title,
        options: col.options,
        index: index,
        rules: col.rules,
        handleSave,
        type: col.type,
        disabled: disabled ?? col.disabled,
        value: col.value,
      }),
    };
  });
  useEffect(() => {
  }, [data])
  return (
    <Table
      rowKey={(record) => record.key}
      {...rest}
      components={components}
      bordered
      dataSource={data}
      columns={columns}
    />
  );
};

export default TableInputAdd2;
